module.exports = "https://bin.bnbstatic.com/_next/static/images/DOCK_landing_page-EN-29756b337baffa83960642c9852fc93c.jpg";